/**
 * Strip lightweight About markdown/highlight syntax for plain-text contexts (SEO, vCard, etc.).
 */
export function stripAboutFormatting(raw) {
  if (!raw || typeof raw !== 'string') return '';
  let s = raw;
  s = s.replace(/==([^=\n]+)==/g, '$1');
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  s = s.replace(/__([^_]+)__/g, '$1');
  s = s.replace(/~~([^~]+)~~/g, '$1');
  s = s.replace(/`([^`]+)`/g, '$1');
  s = s.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1');
  s = s.replace(/\*([^*\n]+)\*/g, '$1');
  s = s.replace(/_([^_\n]+)_/g, '$1');
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}
